var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.5002 17.5L13.881 13.8808M13.881 13.8808C14.5001 13.2618 14.9912 12.5268 15.3262 11.718C15.6612 10.9091 15.8337 10.0422 15.8337 9.16667C15.8337 8.29116 15.6612 7.42424 15.3262 6.61538C14.9912 5.80652 14.5001 5.07157 13.881 4.4525C13.2619 3.83343 12.527 3.34235 11.7181 3.00731C10.9093 2.67227 10.0423 2.49983 9.16684 2.49983C8.29134 2.49983 7.42441 2.67227 6.61555 3.00731C5.80669 3.34235 5.07174 3.83343 4.45267 4.4525C3.2024 5.70277 2.5 7.39851 2.5 9.16667C2.5 10.9348 3.2024 12.6306 4.45267 13.8808C5.70295 15.1311 7.39868 15.8335 9.16684 15.8335C10.935 15.8335 12.6307 15.1311 13.881 13.8808Z",
    stroke: "#515151",
    strokeWidth: 1.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.bbe72e2273452ad88915ecafcc67c7a8.svg";
export { ForwardRef as ReactComponent };